angular.module('TetherApp').controller('GiftWithPurchaseReportRejectionController', [
    '$controller',
    '$mdDialog',
    function (
        $controller,
        $mdDialog
    ) {
        let self = this;

        self.participantController = $controller('ParticipantController');

        self.getImagePreviewModal = function(ev, entryId, imageUrl) {
            self.imagePreviewModalEntryId = entryId;
            self.imagePreviewModalImageUrl = imageUrl;
            ImagePreviewModalController.$inject = ['$mdDialog'];
            $mdDialog.show({
                controller: ImagePreviewModalController,
                controllerAs: 'ctrl',
                templateUrl: '/experience/gift-with-purchase/report/rejection/modals/image-preview',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                escapeToClose: true
            });
        };

        let ImagePreviewModalController = function ($mdDialog) {
            let dCtrl = this;
            dCtrl.entryId = self.imagePreviewModalEntryId;
            dCtrl.imageUrl = self.imagePreviewModalImageUrl;

            dCtrl.hide = function () {
                $mdDialog.hide();
            };

            dCtrl.cancel = function () {
                $mdDialog.cancel();
            };
        };
    }
]);
